import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Atletas
export const atletasAPI = {
  listar: () => api.get('/atletas'),
  obter: (id) => api.get(`/atletas/${id}`),
  criar: (data) => api.post('/atletas', data),
  atualizar: (id, data) => api.put(`/atletas/${id}`, data),
  deletar: (id) => api.delete(`/atletas/${id}`),
};

// Eventos
export const eventosAPI = {
  listar: () => api.get('/eventos'),
  obter: (id) => api.get(`/eventos/${id}`),
  criar: (data) => api.post('/eventos', data),
  atualizar: (id, data) => api.put(`/eventos/${id}`, data),
  deletar: (id) => api.delete(`/eventos/${id}`),
};

// Conquistas
export const conquistasAPI = {
  listar: () => api.get('/conquistas'),
  criar: (data) => api.post('/conquistas', data),
  atualizar: (id, data) => api.put(`/conquistas/${id}`, data),
  deletar: (id) => api.delete(`/conquistas/${id}`),
};

// Notícias
export const noticiasAPI = {
  listar: () => api.get('/noticias'),
  criar: (data) => api.post('/noticias', data),
  atualizar: (id, data) => api.put(`/noticias/${id}`, data),
  deletar: (id) => api.delete(`/noticias/${id}`),
};

// Galeria
export const galeriaAPI = {
  listar: () => api.get('/galeria'),
  upload: (formData) => api.post('/galeria/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deletar: (id) => api.delete(`/galeria/${id}`),
};

// Contato
export const contatoAPI = {
  enviar: (data) => api.post('/contato', data),
  listar: () => api.get('/contatos'),
  marcarLido: (id) => api.put(`/contatos/${id}/lido`),
  deletar: (id) => api.delete(`/contatos/${id}`),
};

// Configurações
export const configAPI = {
  obter: () => api.get('/configuracoes'),
  atualizar: (data) => api.put('/configuracoes', data),
};

// Admin Stats
export const adminAPI = {
  stats: () => api.get('/admin/stats'),
};

export { API, BACKEND_URL };
export default api;
